module OfficeExt {
  export class MsAjaxTypeHelper {
    public static isInstanceOfType(type: any, instance: any): boolean {
      if (typeof instance === "undefined" || instance === null) return false;
      if (instance instanceof type) return true;
      var instanceType = instance.constructor;
      if (
        !instanceType ||
        typeof instanceType !== "function" ||
        !instanceType.__typeName ||
        instanceType.__typeName === "Object"
      ) {
        instanceType = Object;
      }
      return (
        !!(instanceType === type) ||
        (instanceType.__typeName && type.__typeName && instanceType.__typeName === type.__typeName)
      );
    }
  }
  export class MsAjaxError {
    public static create(message: string, errorInfo?: any): Error {
      var err = new Error(message);
      err.message = message;
      if (errorInfo) {
        for (var v in errorInfo) {
          err[v] = errorInfo[v];
        }
      }
      err.popStackFrame();
      return err;
    }
    public static parameterCount(message?: string): Error {
      var displayMessage = "Sys.ParameterCountException: " + (message ? message : "Parameter count mismatch.");
      var err = MsAjaxError.create(displayMessage, { name: "Sys.ParameterCountException" });
      err.popStackFrame();
      return err;
    }
    public static argument(paramName?: string, message?: string): Error {
      var displayMessage =
        "Sys.ArgumentException: " + (message ? message : "Value does not fall within the expected range.");
      if (paramName) {
        displayMessage += "\n" + MsAjaxString.format("Parameter name: {0}", paramName);
      }
      var err = MsAjaxError.create(displayMessage, { name: "Sys.ArgumentException", paramName: paramName });
      err.popStackFrame();
      return err;
    }
    public static argumentNull(paramName?: string, message?: string): Error {
      var displayMessage = "Sys.ArgumentNullException: " + (message ? message : "Value cannot be null.");
      if (paramName) {
        displayMessage += "\n" + MsAjaxString.format("Parameter name: {0}", paramName);
      }
      var err = MsAjaxError.create(displayMessage, { name: "Sys.ArgumentNullException", paramName: paramName });
      err.popStackFrame();
      return err;
    }
    public static argumentOutOfRange(paramName?: string, actualValue?: any, message?: string): Error {
      var displayMessage =
        "Sys.ArgumentOutOfRangeException: " +
        (message ? message : "Specified argument was out of the range of valid values.");
      if (paramName) {
        displayMessage += "\n" + MsAjaxString.format("Parameter name: {0}", paramName);
      }
      if (typeof actualValue !== "undefined" && actualValue !== null) {
        displayMessage += "\n" + MsAjaxString.format("Actual value was {0}.", actualValue);
      }
      var err = MsAjaxError.create(displayMessage, {
        name: "Sys.ArgumentOutOfRangeException",
        paramName: paramName,
        actualValue: actualValue,
      });
      err.popStackFrame();
      return err;
    }
    public static argumentType(paramName?: string, actualType?: any, expectedType?: any, message?: string): Error {
      var displayMessage = "Sys.ArgumentTypeException: ";
      if (message) {
        displayMessage += message;
      } else if (actualType && expectedType) {
        displayMessage += MsAjaxString.format(
          "Object of type '{0}' cannot be converted to type '{1}'.",
          actualType.getName ? actualType.getName() : actualType,
          expectedType.getName ? expectedType.getName() : expectedType,
        );
      } else {
        displayMessage += "Object cannot be converted to the required type.";
      }
      if (paramName) {
        displayMessage += "\n" + MsAjaxString.format("Parameter name: {0}", paramName);
      }
      var err = MsAjaxError.create(displayMessage, {
        name: "Sys.ArgumentTypeException",
        paramName: paramName,
        actualType: actualType,
        expectedType: expectedType,
      });
      err.popStackFrame();
      return err;
    }
    public static argumentUndefined(paramName?: string, message?: string): Error {
      var displayMessage = "Sys.ArgumentUndefinedException: " + (message ? message : "Value cannot be undefined.");
      if (paramName) {
        displayMessage += "\n" + MsAjaxString.format("Parameter name: {0}", paramName);
      }
      var err = MsAjaxError.create(displayMessage, { name: "Sys.ArgumentUndefinedException", paramName: paramName });
      err.popStackFrame();
      return err;
    }
    public static invalidOperation(message: string): Error {
      var displayMessage =
        "Sys.InvalidOperationException: " +
        (message ? message : "Operation is not valid due to the current state of the object.");
      var err = MsAjaxError.create(displayMessage, { name: "Sys.InvalidOperationException" });
      err.popStackFrame();
      return err;
    }
  }
  export class MsAjaxString {
    public static format(format: string, ...args: any[]): string {
      var source = format;
      return source.replace(/{(\d+)}/gm, function (match, number) {
        var index = parseInt(number, 10);
        return args[index] === undefined ? "{" + number + "}" : args[index];
      });
    }
    public static startsWith(str: string, prefix: string): boolean {
      return str.substr(0, prefix.length) === prefix;
    }
  }
  export class MsAjaxDebug {
    public static trace(text: string): void {
      // OSFJS: Need pre-processor alternative
      // #ifdef OSFSCRIPT_DEBUG
      // From MsAjax AppendConsole
      if (DEBUG) {
        if (typeof Debug !== "undefined" && Debug.writeln) Debug.writeln(text);
        if (window.console && window.console.log) window.console.log(text);
        if (window.opera && window.opera.postError) window.opera.postError(text);
        if (window.debugService && window.debugService.trace) window.debugService.trace(text);
        // From MsAjax AppendTrace
        var a = document.getElementById("TraceConsole");
        if (a && a.tagName.toUpperCase() === "TEXTAREA") {
          a.appendChild(document.createTextNode(text + "\n"));
        }
      }
      // #endif // OSFSCRIPT_DEBUG
    }
  }
  if (!OsfMsAjaxFactory.isMsAjaxLoaded()) {
    var registerTypeInternal = function registerTypeInternal(type, name, isClass) {
      if (type.__typeName === undefined || type.__typeName === null) {
        type.__typeName = name;
      }
      if (type.__class === undefined || type.__class === null) {
        type.__class = isClass;
      }
    };
    registerTypeInternal(Function, "Function", true);
    registerTypeInternal(Error, "Error", true);
    registerTypeInternal(Object, "Object", true);
    registerTypeInternal(String, "String", true);
    registerTypeInternal(Boolean, "Boolean", true);
    registerTypeInternal(Date, "Date", true);
    registerTypeInternal(Number, "Number", true);
    registerTypeInternal(RegExp, "RegExp", true);
    registerTypeInternal(Array, "Array", true);
    if (!Function.createCallback) {
      Function.createCallback = function Function$createCallback(method, context) {
        /// <summary locid="M:J#Function.createCallback" />
        /// <param name="method" type="Function"></param>
        /// <param name="context" mayBeNull="true"></param>
        /// <returns type="Function"></returns>
        var e = Function._validateParams(arguments, [
          { name: "method", type: Function },
          { name: "context", mayBeNull: true },
        ]);
        if (e) throw e;
        return function () {
          var l = arguments.length;
          if (l > 0) {
            var args = [];
            for (var i = 0; i < l; i++) {
              args[i] = arguments[i];
            }
            args[l] = context;
            return method.apply(this, args);
          }
          return method.call(this, context);
        };
      };
    }
    if (!Function.createDelegate) {
      Function.createDelegate = function Function$createDelegate(instance, method) {
        /// <summary locid="M:J#Function.createDelegate" />
        /// <param name="instance" mayBeNull="true"></param>
        /// <param name="method" type="Function"></param>
        /// <returns type="Function"></returns>
        var e = Function._validateParams(arguments, [
          { name: "instance", mayBeNull: true },
          { name: "method", type: Function },
        ]);
        if (e) throw e;
        return function () {
          return method.apply(instance, arguments);
        };
      };
    }
    if (!Function._validateParams) {
      // Required methods from MicrosoftAjax - since Excel has switched to aacorlib.js
      Function._validateParams = function (params, expectedParams, validateParameterCount) {
        var e,
          expectedLength = expectedParams.length;
        validateParameterCount = validateParameterCount || typeof validateParameterCount === "undefined";
        e = Function._validateParameterCount(params, expectedParams, validateParameterCount);
        if (e) {
          e.popStackFrame();
          return e;
        }
        for (var i = 0, l = params.length; i < l; i++) {
          var expectedParam = expectedParams[Math.min(i, expectedLength - 1)],
            paramName = expectedParam.name;
          if (expectedParam.parameterArray) {
            paramName += "[" + (i - expectedLength + 1) + "]";
          } else if (!validateParameterCount && i >= expectedLength) {
            break;
          }
          e = Function._validateParameter(params[i], expectedParam, paramName);
          if (e) {
            e.popStackFrame();
            return e;
          }
        }
        return null;
      };
    }
    if (!Function._validateParameterCount) {
      Function._validateParameterCount = function (params, expectedParams, validateParameterCount) {
        var i,
          error,
          expectedLen = expectedParams.length,
          actualLen = params.length;
        if (actualLen < expectedLen) {
          var minParams = expectedLen;
          for (i = 0; i < expectedLen; i++) {
            var param = expectedParams[i];
            if (param.optional || param.parameterArray) {
              minParams--;
            }
          }
          if (actualLen < minParams) {
            error = true;
          }
        } else if (validateParameterCount && actualLen > expectedLen) {
          error = true;
          for (i = 0; i < expectedLen; i++) {
            if (expectedParams[i].parameterArray) {
              error = false;
              break;
            }
          }
        }
        if (error) {
          var e = MsAjaxError.parameterCount();
          e.popStackFrame();
          return e;
        }
        return null;
      };
    }
    if (!Function._validateParameter) {
      Function._validateParameter = function (param, expectedParam, paramName) {
        var e,
          expectedType = expectedParam.type,
          expectedInteger = !!expectedParam.integer,
          expectedDomElement = !!expectedParam.domElement,
          mayBeNull = !!expectedParam.mayBeNull;
        e = Function._validateParameterType(
          param,
          expectedType,
          expectedInteger,
          expectedDomElement,
          mayBeNull,
          paramName,
        );
        if (e) {
          e.popStackFrame();
          return e;
        }
        var expectedElementType = expectedParam.elementType,
          elementMayBeNull = !!expectedParam.elementMayBeNull;
        if (
          expectedType === Array &&
          typeof param !== "undefined" &&
          param !== null &&
          (expectedElementType || !elementMayBeNull)
        ) {
          var expectedElementInteger = !!expectedParam.elementInteger,
            expectedElementDomElement = !!expectedParam.elementDomElement;
          for (var i = 0; i < param.length; i++) {
            var elem = param[i];
            e = Function._validateParameterType(
              elem,
              expectedElementType,
              expectedElementInteger,
              expectedElementDomElement,
              elementMayBeNull,
              paramName + "[" + i + "]",
            );
            if (e) {
              e.popStackFrame();
              return e;
            }
          }
        }
        return null;
      };
    }
    if (!Function._validateParameterType) {
      Function._validateParameterType = function (
        param,
        expectedType,
        expectedInteger,
        expectedDomElement,
        mayBeNull,
        paramName,
      ) {
        var e, i;
        if (typeof param === "undefined") {
          if (mayBeNull) {
            return null;
          } else {
            e = OfficeExt.MsAjaxError.argumentUndefined(paramName);
            e.popStackFrame();
            return e;
          }
        }
        if (param === null) {
          if (mayBeNull) {
            return null;
          } else {
            e = OfficeExt.MsAjaxError.argumentNull(paramName);
            e.popStackFrame();
            return e;
          }
        }
        if (expectedType && !OfficeExt.MsAjaxTypeHelper.isInstanceOfType(expectedType, param)) {
          e = OfficeExt.MsAjaxError.argumentType(paramName, typeof param, expectedType);
          e.popStackFrame();
          return e;
        }
        return null;
      };
    }
    if (typeof window !== "undefined" && !(window as any).Type) {
      (window as any).Type = Function;
    }
    if (typeof Type !== "undefined" && !Type.registerNamespace) {
      Type.registerNamespace = function (ns) {
        var namespaceParts = ns.split(".");
        var currentNamespace: any = window;
        for (var i = 0; i < namespaceParts.length; i++) {
          currentNamespace[namespaceParts[i]] = currentNamespace[namespaceParts[i]] || {};
          currentNamespace = currentNamespace[namespaceParts[i]];
        }
      };
    }
    if (typeof Type !== "undefined" && !Type.prototype.registerClass) {
      Type.prototype.registerClass = function (cls) {
        cls = {};
      };
    }
    if (typeof Sys === "undefined" && typeof Type !== "undefined") {
      Type.registerNamespace("Sys");
    }
    if (!Error.prototype.popStackFrame) {
      Error.prototype.popStackFrame = function () {
        if (arguments.length !== 0) throw MsAjaxError.parameterCount();
        if (
          typeof this.stack === "undefined" ||
          this.stack === null ||
          typeof this.fileName === "undefined" ||
          this.fileName === null ||
          typeof this.lineNumber === "undefined" ||
          this.lineNumber === null
        ) {
          return;
        }
        var stackFrames = this.stack.split("\n");
        var currentFrame = stackFrames[0];
        var pattern = this.fileName + ":" + this.lineNumber;
        while (typeof currentFrame !== "undefined" && currentFrame !== null && currentFrame.indexOf(pattern) === -1) {
          stackFrames.shift();
          currentFrame = stackFrames[0];
        }
        var nextFrame = stackFrames[1];
        if (typeof nextFrame === "undefined" || nextFrame === null) {
          return;
        }
        var nextFrameParts = nextFrame.match(/@(.*):(\d+)$/);
        if (typeof nextFrameParts === "undefined" || nextFrameParts === null) {
          return;
        }
        this.fileName = nextFrameParts[1];
        this.lineNumber = parseInt(nextFrameParts[2]);
        stackFrames.shift();
        this.stack = stackFrames.join("\n");
      };
    }
    // Set the custom implementation MS Ajax objects used by OsfMsAjaxFactory
    OsfMsAjaxFactory.msAjaxError = MsAjaxError as IMsAjaxError;
    OsfMsAjaxFactory.msAjaxString = MsAjaxString as IMsAjaxString;
    OsfMsAjaxFactory.msAjaxDebug = MsAjaxDebug as IMsAjaxDebug;
  }
}
